import { Button, VStack, FormControl, FormLabel, Box, Text, useToast } from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "index";
import { useEffect, useState } from "react";
import PasswordInput from "components/elements/PasswordInput";
import AuthBox from "components/elements/AuthBox";
import { AuthHeading } from "components/layout/AuthLayout";
import { getErrorMessage } from "utils/errorHandler";
import { useCurrentUserQuery } from "modules/tenant/queries/use-current-user-query";

function Update() {
  const toast = useToast();
  const navigate = useNavigate();

  const { refetch } = useCurrentUserQuery();
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmP, setConfirmP] = useState("");

  const resetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault();
      setIsLoading(true);
      const { error } = await supabase.auth.updateUser({
        password,
        data: { password_set: true },
      });

      if (error) {
        throw new Error(getErrorMessage(error));
      }

      await refetch();

      toast({
        title: "Password Reset",
        description: "Your password was successfully reset!",
      });

      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      toast({
        title: "Login Failed",
        description: getErrorMessage(err),
        status: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.analytics.page("Update Password");
  }, []);

  return (
    <AuthBox>
      <AuthHeading title="Set New Password" />
      <Box w="370px">
        <form onSubmit={resetPassword}>
          <FormControl mt="16px">
            <FormLabel variant="onboarding">New Password</FormLabel>
            <PasswordInput value={password} onChange={setPassword} />
          </FormControl>
          <FormControl mt="16px">
            <FormLabel variant="onboarding">Confirm Password</FormLabel>
            <PasswordInput value={confirmP} onChange={setConfirmP} placeholder="Confirm Password" />
          </FormControl>
          <VStack>
            <Button
              isLoading={isLoading}
              colorScheme="blue"
              type="submit"
              mt="24px"
              mb="20px"
              px="36px"
            >
              Update Password
            </Button>
            <Text fontSize="16px">
              Have an account?{" "}
              <Link to="/login" color="primary">
                Log In
              </Link>
            </Text>
          </VStack>
        </form>
      </Box>
    </AuthBox>
  );
}

export default Update;
